import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useDispatch, useSelector } from '../../../../redux/store';
import { OrderGuide } from '../../../../components/dashboard/admin/order-guides';
import { getAllProducts } from '../../../../redux/slices/orderGuides';

export default function OrderGuideParent() {
  const dispatch = useDispatch();
  const { isLoadingProducts, data: { allProducts } } = useSelector((state) => state.orderGuides);


  useEffect(() => {
    if (!allProducts?.length && !isLoadingProducts) dispatch(getAllProducts());
  }, [allProducts, dispatch]);

  return (
    <>
      <Helmet>
        <title>Admin Order guide | Platform Solutions</title>
      </Helmet>

      <OrderGuide />
    </>
  );
}
